import React, { useState, useEffect } from 'react';
import apiClient from '../../../api/apiClient';
import { publish, subscribe, unsubscribe } from '../../../utils/pubsubWrapper';
import { Table, Form, InputGroup, Container, Row, Col, Pagination, Button } from 'react-bootstrap';
import { getTags, formatDate, scrollToTop } from '../../../utils/utils';
import ViewOptions from "./ViewOptions";
import { EditIcon, ViewIcon, DeleteIcon } from '../../../utils/FontIcon';
import { PopupModel, AlertMassage,ShowMoreText } from '../../shared';
import { GETQUIZ } from '../../../utils/ApiEndPoint';

const QuestionList = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [questions, setQuestions] = useState([]);
  const [popupData, setPopupData] = useState({
    show: false,
    title: '',
    type: '',
    selectedItem: {},
  });
  const [showAlert, setShowAlert] = useState({
    type: '',
    title: '',
    msg: ``,
    show: false

  });
  const [search, setSearch] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  useEffect(() => {
    fetchQuestions();
  }, []);
  useEffect(() => {
    const pubsubToken = subscribe('FETCH_QUESTION', () => {
      fetchQuestions();
    });
    return () => unsubscribe(pubsubToken);
  }, []);
  const fetchQuestions = () => {
    setLoading(true)
    apiClient.get(GETQUIZ)
      .then((response) => {
        if (response.status === 200) {
          setQuestions(response.data);
        } else {
          setError('Failed to load questions');
        }
      }).catch((error) => {
        console.error('Failed to fetch questions:', error);
        setError('Failed to load questions');
      }).finally(() => {
        setLoading(false);
      });
  };
  const handleCloseModal = () => {
    setPopupData({
      show: false,
      title: '',
      type: '',
      selectedItem: {},
    })
  };
  const handelAction = (e, actionType, item) => {
    switch (actionType) {
      case 'edit':
        publish('EDIT_QUESTION_GROUP', item);
        scrollToTop();
        break;
      case 'viewquestion':
        setPopupData({
          show: true,
          title: item?.title,
          type: 'preview',
          selectedItem: item,
        })
        break;
      case 'delete':
        setPopupData({
          show: true,
          title: 'Confirm!',
          type: 'confirm',
          selectedItem: item,
        })
        break;
    }
  }
  const handelDelete = async () => {
    const data = {
      "deletedBy": popupData.selectedItem?.createdBy,
    }
    const id = popupData.selectedItem?._id;
    const title = popupData.selectedItem?.title;
    let tempAlert = {
      type: 'danger',
      title: 'Error',
      msg: '',
      show: true
    }
    apiClient.patch(`${GETQUIZ}/${id}/soft-delete`, data)
      .then((response) => {
        if (response.status === 200) {
          tempAlert.type = 'success';
          tempAlert.title = 'success';
          tempAlert.msg = `${title} is deleted successfully`;
          setShowAlert(tempAlert);
          fetchQuestions()
        } else {
          tempAlert.msg = `Failed to delete ${title}`;
          setShowAlert(tempAlert);
        }
      }).catch((error) => {
        tempAlert.msg = `Failed to delete ${title} ${JSON.stringify(error)}`;
        setShowAlert(tempAlert);
      }).finally(() => {
        handleCloseModal();
      });
  }
  const hideAlert = () => {
    setShowAlert({
      type: '',
      title: '',
      msg: '',
      show: false
    })
  }

  const filteredQuestions = questions.filter(question => {
    const searchLower = search.toLowerCase();
    return (
      (question?.title?.toLowerCase().includes(searchLower)) ||
      (Array.isArray(question.tags) ? question.tags.join(' ').toLowerCase() : '').includes(searchLower)
    );
  });

  const paginatedQuestions = filteredQuestions.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  const totalPages = Math.ceil(filteredQuestions.length / pageSize);
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const tableBody = paginatedQuestions.map((question, idx) => {
    return question.title && <tr key={idx + (currentPage - 1) * pageSize}>
      <td>
        {(currentPage - 1) * pageSize + idx + 1}
      </td>
      <td>{question.title}</td>
      <td><ShowMoreText text={question.description} maxLength={40} /></td>
      <td>{question.questions.length}</td>
      <td>{question.tags && question.tags.length ? getTags(question.tags) : ''}</td>
      <td>{formatDate(question.createdAt)}</td>
      <td>{question.createdBy ? question.createdBy : ''}</td>
      <td>
        <div style={{ display: 'flex', paddingBlock: '1rem' }}>
          <a
            style={{ cursor: 'pointer', marginLeft: '10px', marginRight: '10px' }}
            onClick={(e) => handelAction(e, 'edit', question)}
            title={'Edit'}>
            <EditIcon />
          </a>
          <a
            style={{ cursor: 'pointer', marginLeft: '10px', marginRight: '10px' }}
            onClick={(e) => handelAction(e, 'viewquestion', question)}
            title={'View'}>
            <ViewIcon />
          </a>
          <a
            style={{ cursor: 'pointer', marginLeft: '10px', marginRight: '10px' }}
            onClick={(e) => handelAction(e, 'delete', question)}
            title={'Delete'}>
            <DeleteIcon />
          </a>

        </div>
      </td>
    </tr>
  })

  if (loading) return <p className='p-2 w-100 text-center m-3 bg-light'>Loading questions...</p>;
  if (error) return <p className='p-2 w-100 text-center m-3 bg-light'>{error}</p>;
  return (
    <Container fluid className="mt-2 px-4">
      <Row className="justify-content-between align-items-center mb-1">
        <Col md={6}>
          <h6 className="fw-700">Existing Questionnaire List</h6>
        </Col>
        <Col md={4} className='p-relative'>
          <InputGroup>
            <Form.Control
              placeholder="Search question..."
              type='search'
              value={search}
              onChange={e => setSearch(e.target.value)}
              className='searchbox-input'
            />
          </InputGroup>
          <span className='search-icon2'></span>
        </Col>
      </Row>
      <Table responsive className='mytable'>
        <thead >
          <tr>
            <th scope="col">S.No.</th>
            <th scope="col">Title</th>
            <th scope="col">Description</th>
            <th scope="col">Total questions</th>
            <th scope="col" className='text-nowrap'>Keywords</th>
            <th scope="col" className='text-nowrap'>Created at</th>
            <th scope="col" className='text-nowrap'>Created by</th>
            <th scope="col" className='text-nowrap'>Actions</th>
          </tr>
        </thead>
        <tbody>
          {tableBody}
        </tbody>
      </Table>
      <div className="d-flex justify-content-center">
        <Pagination className='mypagination-listing'>
          <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
          <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
          {[...Array(totalPages)].map((_, idx) => (
            <Pagination.Item
              key={idx + 1}
              active={currentPage === idx + 1}
              onClick={() => handlePageChange(idx + 1)}
            >
              {idx + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
          <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
        </Pagination>
      </div>
      {popupData.show ?
        popupData.type === 'confirm' ?
          <PopupModel
            size='md'
            showModal={popupData.show}
            handleCloseModal={handleCloseModal}
            title={popupData.title}
            type={popupData.type}
            footerContent={
              <>
                <Button variant="danger" onClick={handelDelete}>Yes</Button>
                <Button variant="info" onClick={handleCloseModal}>No</Button>
              </>
            }
          >
            <p>Are you sure you want to delete <strong>{popupData.selectedItem.title}</strong> ? This action cannot be undone.</p>
          </PopupModel> :
          <PopupModel
            size='lg'
            showModal={popupData.show}
            handleCloseModal={handleCloseModal}
            title={popupData.title}
            type={popupData.type}
          >
            {
              <Row>
                {popupData?.selectedItem?.questions.map((question, index) => {
                  return <Col lg={12} key={index} className='question-preview-listing'>
                    <ViewOptions question={question} />
                  </Col>
                })}
              </Row>
            }
          </PopupModel>
        : null}
      {showAlert.show &&
        <AlertMassage
          show={showAlert.show}
          type={showAlert.type}
          title={showAlert.title}
          massage={showAlert.msg}
          hideAlert={hideAlert} />
      }
    </Container >
  );
};

export default QuestionList;